'use client';

import { SmartLink } from '@/components/smart-link';

export default function ShareCardLink({
  href,
  title,
}: {
  href: string;
  title: string;
}) {
  return (
    <SmartLink
      href={href}
      mode="intent"
      aria-label={title}
      className="absolute inset-0 z-10 rounded-xl focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/40"
      draggable={false}
      onDragStart={(event) => event.preventDefault()}
    >
      <span className="sr-only">{title}</span>
    </SmartLink>
  );
}
